import { render } from "./EventPurchasing.vue?vue&type=template&id=696b4500"
import script from "./EventPurchasing.vue?vue&type=script&lang=js"
export * from "./EventPurchasing.vue?vue&type=script&lang=js"

import "./EventPurchasing.vue?vue&type=style&index=0&id=696b4500&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__